export const formatName = (data) => {
  if (!data) {
    return {
      fullName: "Unknown User",
      initials: "",
    };
  }
  const firstName = data.FIRST_NAME || "";
  const lastName = data.LAST_NAME || "";
  const roleName = data.ROLE_NAME || "";
  const facilityName = data.FACILITY_NAME || "";
  const formattedFirstName =
    firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
  const formattedLastName =
    lastName.charAt(0).toUpperCase() + lastName.slice(1).toLowerCase();
  const initials = roleName
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase())
    .join("");
  const fullName = facilityName
    ? facilityName
    : `${formattedFirstName} ${formattedLastName}`;

  return {
    fullName,
    initials,
  };
};

export function compareArrays(arr1, arr2) {
  // Step 1: Check if lengths are the same
  if (arr1.length !== arr2.length) {
    return false;
  }

  // Step 2: Create a helper function to compare objects
  const compareObjects = (obj1, obj2) => {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    // Check if both objects have the same number of keys
    if (keys1.length !== keys2.length) {
      return false;
    }

    // Check if all keys and their values are the same
    for (let key of keys1) {
      if (obj1[key] !== obj2[key]) {
        return false;
      }
    }

    return true;
  };

  // Step 3: Sort both arrays (if order doesn't matter)
  const sortedArr1 = arr1
    .slice()
    .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
  const sortedArr2 = arr2
    .slice()
    .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));

  // Step 4: Compare each object in the sorted arrays
  for (let i = 0; i < sortedArr1.length; i++) {
    if (!compareObjects(sortedArr1[i], sortedArr2[i])) {
      return false;
    }
  }

  return true;
}

export const influncerOptions = [
  "Influncer",
  "Call In",
  "Career Builder",
  "Facebook",
  "Google",
  "Indeed Application",
  "Instagram",
  "Job Fair",
  "LinkedIn",
  "Monster",
  "Other",
  "Referral",
  "TikTok",
  "Walk In",
  "Website",
];

export const DurationInYearOption = [
  "Less than 1 year",
  "1 year",
  "2 years",
  "3 years",
  "4 years",
  "5 years",
  "6 years",
  "7 years",
  "8 years",
  "9 years",
  "10 years",
  "11 years",
  "12 years",
  "13 years",
  "14 years",
  "15 years",
  "More than 15 years",
];

export const handleAlphabeticInput = (e) => {
  let value = e.target.value.replace(/[^a-zA-Z]/g, ""); // Allow only alphabets
  e.target.value = value.charAt(0).toUpperCase() + value.slice(1); // Capitalize the first letter
};
export const capitalizeFirstLetter = (text) => {
  if (!text) return "";
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
};


//  Fix in genericMethod.js
export async function formatDate(dateString) {
  if (!dateString) return "";
  try {
    const options = { day: "2-digit", month: "short", year: "numeric" };

    //  For UTC ISO strings like "2026-02-18T18:30:00.000Z" — use UTC methods
    if (typeof dateString === "string" && dateString.includes("Z")) {
      const date = new Date(dateString);
      const utcDate = new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
      );
      return utcDate.toLocaleDateString("en-GB", options).replace(",", "");
    }

    //  For "YYYY-MM-DD" or "YYYY-MM-DDTHH:mm:ss" — parse as local time
    if (typeof dateString === "string" && dateString.includes("-")) {
      const datePart = dateString.split("T")[0];
      const [year, month, day] = datePart.split("-").map(Number);
      if (year && month && day) {
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString("en-GB", options).replace(",", "");
      }
    }

    return dateString;
  } catch (e) {
    console.error("formatDate error:", e);
    return dateString;
  }
}

//without
export function formatDateMONTH_DD_YYYY(dateString) {
  if (!dateString) return ""; // Ensure no invalid date processing

  const options = { month: "long", day: "2-digit", year: "numeric" };
  const date = new Date(dateString);

  return date.toLocaleDateString("en-US", options); // Example: "June 30, 2024"
}
export function formatTime(timestamp) {
  const date = new Date(timestamp);

  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12; // 0 becomes 12
  const minutesStr = minutes < 10 ? "0" + minutes : minutes;

  return `${hours}:${minutesStr} ${ampm}`;
}

export async function getStringAfterLastSlash(str) {
  // Find the position of the last '/'
  const lastSlashIndex = str.lastIndexOf("/");

  // Extract the substring after the last '/'
  return str.substring(lastSlashIndex + 1);
}
//Functionality to get dynamic colors along with unique color on adjacent edge of each item.

export const assignedColorList = (items, colors) => {
  const assignedColors = [];
  return new Promise((resolve, reject) => {
    items.forEach((item, index) => {
      let color;
      // color=  colors[index]
      console.log("OUT", index);
      do {
        console.log("IN", index);

        color = colors[Math.floor(Math.random() * colors.length)];
      } while (index > 0 && color === assignedColors[index - 1]);

      assignedColors.push(color);
    });

    if (assignedColors.length > 0) {
      resolve(assignedColors);
    } else {
      reject([]);
    }
  });
};

export const calculateGrandTotalTime = (entries) => {
  const totalMinutes = entries.reduce((total, entry) => {
    const [hours, minutes] = entry.totalTime.split(" ");
    const hoursInMinutes = parseInt(hours.replace("h", ""), 10) || 0;
    const mins = parseInt(minutes.replace("m", ""), 10) || 0;
    const entryTimeInMinutes = hoursInMinutes * 60 + mins;

    if (entry.Time_Entry === "Meal Time" || entry.Time_Entry === "Free Time") {
      return total - entryTimeInMinutes;
    }

    return total + entryTimeInMinutes;
  }, 0);
  const totalHours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;
  return `${totalHours}h ${remainingMinutes}m`;
};

// export async function generateJobDatesWeekly(startDate, endDate, jobDays) {
//     console.log(startDate, endDate, jobDays);

//     let jobSchedule = [];
//     let currentDate = new Date(startDate);
//     const finalDate = new Date(endDate); // Ensure endDate is parsed properly

//     while (currentDate <= finalDate) {
//         const dayOfWeek = currentDate.toLocaleString('en-us', { weekday: 'long' });

//         const jobForDay = jobDays.find(job => job.JOB_DAY === dayOfWeek);
//         if (jobForDay) {
//             jobSchedule.push({
//                 jobDate: new Date(currentDate).toISOString().split('T')[0], // Format as YYYY-MM-DD
//                 startTime: jobForDay.JOB_IN_TIME,
//                 endTime: jobForDay.JOB_OUT_TIME,
//                 jobID: jobForDay.JOB_ID,
//                 id: `${jobForDay.JOB_ID}-${new Date(currentDate).toISOString().split('T')[0]}`, // Unique ID
//             });
//         }

//         currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
//     }

//     return jobSchedule;
// }
export async function generateJobDatesWeekly(startDate, endDate, jobDays) {
  return new Promise((resolve, reject) => {
    console.log(startDate, endDate, jobDays);
    try {
      let jobSchedule = [];
      let currentDate = new Date(startDate);
      const finalDate = new Date(endDate); // Ensure endDate is parsed properly

      while (currentDate <= finalDate) {
        const dayOfWeek = currentDate.toLocaleString("en-us", {
          weekday: "long",
        });

        const jobForDay = jobDays.find((job) => job.JOB_DAY === dayOfWeek);
        if (jobForDay) {
          jobSchedule.push({
            jobDate: new Date(currentDate).toISOString().split("T")[0], // Format as YYYY-MM-DD
            startTime: jobForDay.JOB_IN_TIME,
            endTime: jobForDay.JOB_OUT_TIME,
            jobID: jobForDay.JOB_ID,
            id: `${jobForDay.JOB_ID}-${new Date(currentDate).toISOString().split("T")[0]}`, // Unique ID
          });
        }

        currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
      }
      console.log("jobSchedule", jobSchedule);
      resolve(jobSchedule); // Resolve the promise with the final schedule
    } catch (error) {
      reject(error); // Reject the promise in case of any error
    }
  });
}

export const getStatusColor = (status) => {
  switch (status) {
    case "Interview":
      return "rgba(255, 123, 0, 0.92)";
    case "Pending":
      return "rgba(255,165,0,0.9)"; // Orange for Pending
    case "Interested":
      return "rgba(0,0,255,0.8)"; // Blue for Interested
    case "Hired":
      return "rgba(0,128,0,0.8)"; // Green for Hired
    case "Reject":
      return "rgba(255,0,0,0.8)"; // Red for Reject
    default:
      return "rgba(0,0,0,0.6)"; // Default color
  }
};

export const getStatusBgColor = (status) => {
  switch (status) {
    case "Interview":
      return "rgba(255, 123, 0, 0.2)";
    case "Pending":
      return "rgba(255,165,0,0.1)";
    case "Interested":
      return "rgba(0,0,255,0.1)";
    case "Hired":
      return "rgba(0,128,0,0.1)";
    case "Reject":
      return "rgba(255,0,0,0.1)";
    default:
      return "rgba(0,0,0,0.05)";
  }
};

export const getStatusonJobCard = (status) => {
  switch (status) {
    case "Pending":
      return "Pending Action";
    case "Interested":
      return "Applied";
    case "Hired":
      return "Hired";
    case "Rejected":
      return "Rejected";
    case "Under Review":
      return "Under Review";
    case "Declined":
      return "Rejected by you";
    case "Interview":
      return "Interview Schedule";

    default:
      return "Not Applied / Requested";
  }
};

export function calculateTotalHoursPayment(totalTime, settledRate) {
  // Parsing hours and minutes
  const [hours, minutes] = totalTime.split("h").map((part) => parseInt(part));
  const totalHours = hours + minutes / 60; // converting minutes to fractional hours
  const totalPayment = parseFloat(totalHours * settledRate).toFixed(2);

  return totalPayment;
}

export function formatDayAndTime(dateTime) {
  if (!dateTime) return "";

  const date = new Date(dateTime);
  const options = { weekday: "short" }; // Short weekday name (Mon, Tue, etc.)
  const day = date.toLocaleDateString("en-US", options);

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day} ${hours}:${minutes}`;
}
export const isValidUUID = (value) => {
  const UUID_REGEX =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return UUID_REGEX.test(value);
};

export function formatLocalDateTime(dateTime) {
  if (!(dateTime instanceof Date) || isNaN(dateTime)) {
    console.warn("Invalid Date object passed to formatLocalDateTime");
    return null;
  }

  const year = dateTime.getFullYear();
  const month = String(dateTime.getMonth() + 1).padStart(2, "0");
  const day = String(dateTime.getDate()).padStart(2, "0");

  const hours = String(dateTime.getHours()).padStart(2, "0");
  const minutes = String(dateTime.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:00`;
}

export function formatDateAndTime(isoString) {
  const date = new Date(isoString);

  const options = {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  // Get formatted parts
  const localeString = date.toLocaleString("en-US", options);

  // Inject comma after month
  const [datePart, timePart] = localeString.split(", ");
  const formattedDate = datePart.replace(/(\d{2}) (\w+)/, "$1 $2,");

  return `${formattedDate} ${timePart}`;
}

export function formatDateAndTimeUTC(isoString) {
  // Parse ISO string WITHOUT timezone conversion
  // Format: 2026-03-19T20:20:00.000Z -> Mar 19, 2026 at 8:20 PM
  const match = isoString?.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):\d{2}/);
  if (!match) return "—";
  
  const [, year, month, day, hours, minutes] = match;
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const monthName = monthNames[parseInt(month) - 1];
  
  // Convert 24-hour to 12-hour format
  const hour12 = parseInt(hours) % 12 || 12;
  const ampm = parseInt(hours) >= 12 ? "PM" : "AM";
  
  return `${monthName} ${parseInt(day)}, ${year} at ${hour12}:${minutes} ${ampm}`;
}

//Accounting Screen Admin
export function formatDate1(date) {
  return date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
}

export function getDateTime(date, endOfDay = false) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate(),
  ).padStart(2, "0")} ${endOfDay ? "23:59:59" : "00:00:00"}`;
}

export function getPayPeriods(currentDate = new Date()) {
  const thisMonth = new Date(currentDate.getFullYear(), currentDate.getMonth());
  const nextMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
  );

  const getRange = (date, startDay, endDay, crossMonth = false) => {
    const from = new Date(date.getFullYear(), date.getMonth(), startDay);
    const to = crossMonth
      ? new Date(date.getFullYear(), date.getMonth() + 1, endDay)
      : new Date(date.getFullYear(), date.getMonth(), endDay);
    return {
      label: `${formatDate1(from)} - ${formatDate1(to)}`,
      from: getDateTime(from),
      to: getDateTime(to, true),
    };
  };

  return [
    getRange(thisMonth, 3, 9),
    getRange(thisMonth, 27, 2, true),
    getRange(nextMonth, 3, 9),
  ];
}

export function getDayOption(day) {
  const today = new Date();
  let target = new Date(today);

  if (day === "Yesterday") target.setDate(today.getDate() - 1);
  if (day === "Tomorrow") target.setDate(today.getDate() + 1);

  return {
    label: day,
    from: getDateTime(target),
    to: getDateTime(target, true),
  };
}

export function getMonthOption(type) {
  const now = new Date();
  const start = new Date(
    now.getFullYear(),
    now.getMonth() - (type === "Last Month" ? 1 : 0),
    1,
  );
  const end = new Date(
    now.getFullYear(),
    now.getMonth() + (type === "Last Month" ? 0 : 1),
    0,
  );

  return {
    label: type,
    from: getDateTime(start),
    to: getDateTime(end, true),
  };
}

export const convertToFormData = (data) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (key === "file" && value instanceof File) {
      formData.append(key, value); // attach file
    } else if (value !== undefined && value !== null) {
      formData.append(key, value); // attach string, number, etc.
    }
  });

  return formData;
};
